import autoComplete from "@tarekraafat/autocomplete.js";

export async function locationSuggestions(el, placeholder) {
    if (!el) {
        console.warn("No element found to attach geosearch");
        return;
    }

    const autoCompleteJS = new autoComplete({
        selector: "#" + el.id,
        placeHolder: placeholder ? placeholder : "All locations",
        //searchEngine: (q, r) => r,//Disable search engine
        searchEngine: "loose",
        threshold: 2,
        submit: true,
        data: {
            src: async (query) => {
                try {
                    const source = await fetch(`${el.dataset.source}?query=${query}`);
                    const data = await source.json();

                    return data;
                } catch (error) {
                    return error;
                }
            },
            keys: ["name"],
        },
        resultsList: {
            element: (list, data) => {
                const info = document.createElement("h6");
                info.classList.add("text-primary", "text-center", "mb-0", "p-2");
                if (data.results.length > 0) {
                    info.innerHTML = `Displaying <strong>${data.results.length}</strong> result(s)`;
                }
                list.prepend(info);
            },
            noResults: false,
            maxResults: 100,
            tabSelect: true
        },
        resultItem: {
            element: (item, data) => {
                // Modify Results Item Style
                item.style = "display: flex; justify-content: space-between;";
                // Modify Results Item Content
                item.innerHTML =
                    `
                        <span class="text-truncate">${data.match}</span>
                        <span class="d-flex align-items-center text-gray-500 text-uppercase">${data.value.countryIso}</span>
                    `;
            },
            highlight: true
        },
    });


    autoCompleteJS.input.addEventListener("selection", function (event) {
        const feedback = event.detail;
        autoCompleteJS.input.blur();
        // Prepare User's Selected Value
        const selection = feedback.selection.value[feedback.selection.key];
        // Replace Input value with the selected value
        autoCompleteJS.input.value = selection;
    });

}

export default locationSuggestions;